module.exports = __webpack_public_path__ + "img/logo.99f8a71d.svg";